/** Ошибки API и пустое тело. */
import { z } from "zod";

/** Коды ошибок API. */
export const ApiErrorCode = z.enum([
  "bad_request",
  "unauthorized",
  "forbidden",
  "not_found",
  "conflict",
  "insufficient_coins",
  "insufficient_crystals",
  "max_level",
  "locked",
  "wave_out_of_order",
  "balance_version_unsupported",
  "rate_limited",
  "internal",
]);
export type ApiErrorCode = z.infer<typeof ApiErrorCode>;

/** HTTP-статус для кода ошибки. */
export const ERROR_STATUS: Record<ApiErrorCode, number> = {
  bad_request: 400,
  unauthorized: 401,
  forbidden: 403,
  not_found: 404,
  conflict: 409,
  insufficient_coins: 409,
  insufficient_crystals: 409,
  max_level: 409,
  locked: 409,
  wave_out_of_order: 409,
  balance_version_unsupported: 409,
  rate_limited: 429,
  internal: 500,
};

/** Тело ответа с ошибкой. */
export const ApiErrorBody = z.object({
  error: z.object({
    code: ApiErrorCode,
    /** Текст для логов и отладки, не для игрока (игроку — i18n по `code`). */
    message: z.string(),
  }),
});
export type ApiErrorBody = z.infer<typeof ApiErrorBody>;

/** Пустое тело (GET и POST без параметров). */
export const Empty = z.object({}).strict();

/** Ошибка API с кодом — бросает сервер, ловит транспорт клиента. */
export class ApiError extends Error {
  readonly code: ApiErrorCode;
  constructor(code: ApiErrorCode, message: string = code) {
    super(message);
    this.name = "ApiError";
    this.code = code;
  }
  get status(): number {
    return ERROR_STATUS[this.code];
  }
  toBody(): ApiErrorBody {
    return { error: { code: this.code, message: this.message } };
  }
}
